<template>
    <el-dialog
        v-bind="$props"
        v-on="$listeners"
        class="epoint-dialog"
        :class="[classObj, fadeClassObj]"
        ref="dialog"
        @open="dialogOpen"
        @close="dialogClose"
    >
        <template v-if="$slots.title" v-slot:title>
            <slot name="title">
                <span class="el-dialog__title">{{ title }}</span>
            </slot>
        </template>

        <!-- 组件关闭后必销毁，destroy-on-close属性无效 -->
        <template v-if="visible">
            <slot></slot>
        </template>

        <template v-if="$slots.footer" v-slot:footer>
            <slot name="footer"></slot>
        </template>
    </el-dialog>
</template>

<script>
import {Dialog} from "element-ui";
// import Vue from 'vue';

export default {
    name: "epoint-dialog",
    extends: Dialog,
    props: {
        verticalMiddle: {
            type: Boolean,
            default: true,
        },
        height: {
            type: String,
            default: 'auto',
        },
    },
    data() {
        return {
            timer: null,
            dialogFade: {
                type: Boolean,
                default: true,
            }
        }
    },
    mounted() {
        this.dialogOpen();
    },
    computed: {
        classObj() {
            if (this.verticalMiddle) {
                return {verticalMiddle: true};
            }
            return {};
        },
        fadeClassObj() {
            if (this.dialogFade) {
                return {'dialog-fade-enter-active': true};
            }
            return {};
        },
    },
    beforeDestroy() {
        this.dialogClose();
    },
    methods: {
        // 计算body高度
        calcHeight() {
            let self = this,
                $el = self.$refs.dialog.$el,
                $dialog = $el.querySelector('.el-dialog'),
                $header = $el.querySelector('.el-dialog__header'),
                $footer = $el.querySelector('.el-dialog__footer'),
                $body = $el.querySelector('.el-dialog__body');

            setTimeout(function () {
                self.dialogFade = false;
            }, 1000);

            $dialog.style.height = self.height;

            // 先重置高度
            if ($body) {
                $body.style.height = 'auto';
            }

            let dialogHeight = $dialog.offsetHeight,
                headerHeight = $header ? $header.offsetHeight : 0,
                footerHeight = $footer ? $footer.offsetHeight : 0;

            if ($body) {
                $body.style.height = dialogHeight - headerHeight - footerHeight + 'px';
            }
        },
        // resize计算
        dialogResize() {
            let self = this;
            if (!self.opened) return false;
            if (self.timer) clearTimeout(self.timer);
            self.timer = setTimeout(function () {
                console.log('resize');
                self.calcHeight()
            }, 50);
        },
        dialogOpen() {
            window.addEventListener("resize", this.dialogResize);
            this.calcHeight();
            this.$nextTick(function () {
                this.calcHeight();
            });
        },
        dialogClose() {
            window.removeEventListener('resize', this.dialogResize);
        },
    }
};
</script>

<style lang="scss" scoped>
.epoint-dialog {
    &.verticalMiddle {
        &.el-dialog__wrapper {
            position: fixed !important;
            overflow: hidden !important;
        }

        .el-dialog {
            margin-top: 0 !important;
            top: 50%;
            transform: translateY(-50%);
            max-width: calc(100% - 20px);
            max-height: calc(100% - 20px);
            overflow: hidden;

            > .el-dialog__body {
                overflow: auto;
            }

            &.is-fullscreen {
                height: 100% !important;
                max-width: 100%;
                max-height: 100%;
            }
        }
    }
}
</style>